import { render, staticRenderFns } from "./EvolutionDashboard.vue?vue&type=template&id=6664f7ee&scoped=true&"
import script from "./EvolutionDashboard.vue?vue&type=script&lang=js&"
export * from "./EvolutionDashboard.vue?vue&type=script&lang=js&"
import style0 from "./EvolutionDashboard.vue?vue&type=style&index=0&id=6664f7ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6664f7ee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6664f7ee')) {
      api.createRecord('6664f7ee', component.options)
    } else {
      api.reload('6664f7ee', component.options)
    }
    module.hot.accept("./EvolutionDashboard.vue?vue&type=template&id=6664f7ee&scoped=true&", function () {
      api.rerender('6664f7ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/EvolutionDashboard.vue"
export default component.exports